module.exports = __webpack_public_path__ + "static/media/corporate-services-img82.ca82b07c.jpg";